class ProductCard extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['url', 'track', 'dot']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    // scroll doesn't bubble, so it has to go on the track itself
    this.handleTrackScroll = this.handleTrackScroll.bind(this)
    this.listeners.add(
      this.els.track.element,
      'scroll',
      this.handleTrackScroll,
      {
        passive: true,
      },
    )

    if (!this.els.swatch?.exists) return

    this.handleSwatchClick = this.handleSwatchClick.bind(this)
    this.listeners.add(this, 'click', this.handleSwatchClick)
  }

  handleTrackScroll () {
    const { scrollLeft, clientWidth } = this.els.track.element
    if (!clientWidth) return

    const dots = this.els.dot.elements
    const activeIndex = Math.min(
      Math.round(scrollLeft / clientWidth),
      dots.length - 1,
    )

    dots.forEach((dot, index) => {
      dot.classList.toggle('prd-Card_Dot-active', index === activeIndex)
    })
  }

  async handleSwatchClick (event) {
    const clickedSwatch = event.target.closest(this.els.swatch.selector)
    if (!clickedSwatch) return

    const variantUrl = clickedSwatch.dataset.url

    this.els.swatch.elements?.forEach((el) => {
      el.removeAttribute('aria-current')
      el.removeAttribute('tabindex')
      if (el.dataset.url === variantUrl) {
        el.setAttribute('aria-current', 'true')
        el.setAttribute('tabindex', '-1')
      }
    })

    // Replace specific content
    const templateMedia = clickedSwatch.querySelector(
      'template[data-role="media"]',
    )
    const templateMediaHover = clickedSwatch.querySelector(
      'template[data-role="media-hover"]',
    )

    if (this.els.media?.exists) {
      this.els.media.element.innerHTML = templateMedia?.innerHTML || ''
    }

    // Set media-hover to blank if templateMediaHover is empty
    if (this.els?.['media-hover']?.exists) {
      this.els['media-hover'].elements.forEach((hoverEl) => {
        const hoverHtml = templateMediaHover?.innerHTML?.trim()

        if (hoverHtml) {
          hoverEl.innerHTML = hoverHtml
          hoverEl.hidden = false
        } else {
          hoverEl.innerHTML = ''
          hoverEl.hidden = true
        }
      })
    }

    // The track survives a swap, so go back to image 1. The track has
    // scroll-behavior: smooth; instant keeps the dots from lagging behind
    this.els.track.element.scrollTo({ left: 0, behavior: 'instant' })

    // Replace URLs
    this.els.url.elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })
    this.els.media.elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })
    this.els['media-hover'].elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })

    // Replace quick view trigger URL
    this.els.quick?.elements?.forEach((quickEl) => {
      quickEl.dataset.productUrl = variantUrl
    })
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, { extends: 'article' })
}
